module.exports = __webpack_public_path__ + "img/steward.74c521de.png";